export default {
  ce00e28e28a14624e4d1b3d5da4ba4e4:
    'Confirm the order at the checkout counter - Select the payment method',
  '5d459c2acec131b937ffa8187dddf1bc': '"Alipay Subscription',
  f4357d2202215acb7588ce97be551c33: 'Confirm the order at the checkout counter - payment method',
  '050b13ff8def783c71f936c7ccc00c3f': 'Alipay',
  bb38bad975196de9894fc83ec1653ebc: 'Weixin Pay',
  '8155a5bd453551f9108bc90ff99ce8f9': 'Alipay scan code payment',
  aa360aebbaa7766fcf320dd73211797b: 'Alipay: Learn first, pay later',
  faafa32c8544dee8561a1b905c2558e2: 'Learn first, pay later',
  bd29a1532de9b1711fa58ee6f120bcb3:
    'Trial study for 30 days. Make the payment only if you are satisfied'
};
